

	import { Component, Prop, Watch } from 'vue-property-decorator';
	import { BaseView } from '@shared/views/BaseView';
	import { Deck, DeckSearchRequest, PagedResult } from '@shared/models';
	import DeckItemList from '@client/views/products/decks/DeckItemList.vue';
	import CompanyYearList from './CompanyYearList.vue';
	
	@Component({
		components: {
			DeckItemList,
			CompanyYearList,
		},
	})
	export default class CompanyDecks extends BaseView {

		@Prop()
		public modelId: string;
		public list: PagedResult<Deck> = new PagedResult<Deck>();
		public criteria: DeckSearchRequest = new DeckSearchRequest({ pageIndex: 0, pageSize: 40, sortBy: 'year', sortDirection: 'asc' });
		public yearList: number[] = [];
		public showYearList: boolean = false;
		public sortColumnOptions: any[] = [
			{ text: 'Year', value: 'year' },
			{ text: 'Name', value: 'name' },
			{ text: 'Season', value: 'season' },
			{ text: 'Created Date', value: 'createddate' },
			{ text: 'Last Updated', value: null },
		];
		public sortDirectionOptions: any[] = [
			{ text: 'Asc', value: 'asc' },
			{ text: 'Desc', value: 'desc' },
		];

		@Watch('modelId')
		public async watchModelId() {
			await this.refresh();
		}

		/** Refresh the data in this list */
		@Watch('$route', { immediate: true, deep: true })
		public async refresh() {
			if (!this.modelId) { return; }
			this.loading = true;
			try {
				this.criteria = new DeckSearchRequest(this.$route.query);
				// PUT THIS BACK IN HERE SINCE WE REMOVED IT FROM THE URL
				this.criteria.sortBy = 'year';
				this.criteria.pageSize = 56;
				this.criteria.sortDirection = 'asc';
				this.criteria.companyIds = [ this.modelId ];
				this.list = await this.$api.deckService.search(this.criteria);
				this.showYearList = false;
				if (this.list.pager.totalResults > this.settings.minDecksForYearList) {
					this.showYearList = true;
				}
				this.yearList = [];
				if (this.list.pager.earliestYear && this.list.pager.latestYear) {
					for (let year = this.list.pager.earliestYear; year <= this.list.pager.latestYear; year++) {
						this.yearList.push(year);
					}
				}

			} catch (err) {
				this.errorHandler.handle(err, 'An error occurred while loading this companies deck list');
			} finally {
				this.loading = false;
			}
		}

		/** Fires when a year is selected */
		public async yearSelected(year: number) {
			this.criteria.startYear = year;
			this.criteria.endYear = year;
			await this.filter(true);
		}

		/** Fires the clear year button is clicked */
		public async clearYear() {
			this.criteria.startYear = null;
			this.criteria.endYear = null;
			await this.filter(true);
		}

		/** Fires when the page is changed */
		public async pageChanged(page: number) {
			this.criteria.pageIndex = (page - 1);
			await this.filter(false);
		}

		/** Applies the specified filter and redirects to the new page with the correct query parameters */
		public async filter(resetPage: boolean) {
			this.scroll.scrollToTop();
			if (resetPage) { this.criteria.pageIndex = 0; }
			// REMOVE THIS HERE SO IT DOESN'T SHOW UP IN THE URL
			this.criteria.companyIds = [];
			this.$router.push({ name: 'company-decks', params: { id: this.modelId }, query: this.criteria.collapse() }).catch(() => { /* INTENTIONALLY EMPTY */ });
			await this.refresh();
		}



	}

